export const cardLoyaltyProgramExternal = {
    enabled: false,
    _description:
        'Enables the card loyalty program external feature display on the bank card settings page and card features page',
};
